<div class="my-5">
    <sm-page-header [breadcrumb]="breadcrumb" title="settings.contractingAuthority.ac.consult.title"
        ></sm-page-header>
    
    <div class="content">
        <!-- Logo Display in content section -->
        <div class="px-4 mb-4" *ngIf="contractingAuthorityRepository.getNested('response', 'logo')">
            <div class="">
                <div class="flex justify-center">
                    <img 
                        [src]="logoUrl" 
                        [alt]="contractingAuthorityRepository.getNested('response', 'nom') + ' logo'"
                        class="w-32 h-32 object-contain rounded-lg border-2 border-gray-200 shadow-md"
                    />
                </div>
            </div>
        </div>
        
        <sm-form-builder [formObject]="formObject" class="w-full px-4"></sm-form-builder>
        
        <div class="flex justify-end gap-2">
        </div>
        <p-tabs [(value)]="selectedTab" (valueChange)="onTabChange($event)" scrollable class="mt-4 bg-transparent">
            <p-tablist>
                <p-tab value="members"> {{ 'settings.contractingAuthority.tabs.users' | translate }}</p-tab>
                <p-tab value="seuils"> {{ 'settings.contractingAuthority.tabs.seuils' | translate }}</p-tab>
            </p-tablist>
            <p-tabpanels>
                <p-tabpanel value="members">
                    <sm-members [acId]="contractingAuthorityRepository.getNested('response', 'id')"
                    [members]="contractingAuthorityRepository.getNested('response', 'users')" [isInspectMode]="true"></sm-members>
                </p-tabpanel>
                <p-tabpanel value="seuils">
                    <sm-settings-seuils [acId]="contractingAuthorityRepository.getNested('response', 'id')" [isInspectMode]="true"></sm-settings-seuils>
                </p-tabpanel>
            </p-tabpanels>
        </p-tabs>
    </div>
</div>
